import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight, PackageSearch } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId, waLink } from "@/lib/api";

const LINKS = [
  ["servicos", "Serviços"],
  ["pack-gospel", "Pack Gospel"],
  ["portfolio", "Portfólio"],
  ["sobre", "Sobre"],
];

export const Nav = ({ settings }) => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed top-0 z-50 w-full border-b border-[#163D43] bg-[#041214]/80 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 md:px-10">
        <button onClick={() => go("top")} data-testid="nav-logo">
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`} className="group relative text-sm text-teal-100 transition-colors hover:text-white">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#2DD4BF] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
          <Link to="/acompanhar" data-testid="nav-link-track" className="group relative inline-flex items-center gap-1.5 text-sm text-[#2DD4BF] transition-colors hover:text-white">
            <PackageSearch className="h-4 w-4" /> Acompanhar pedido
          </Link>
        </nav>
        <a href={waLink(settings?.whatsapp)} target="_blank" rel="noreferrer" data-testid="nav-whatsapp-cta" className="hidden items-center gap-2 rounded-full bg-[#2DD4BF] px-5 py-2.5 text-sm font-semibold text-[#041214] transition-transform hover:-translate-y-0.5 md:inline-flex">
          Fazer pedido <ArrowUpRight className="h-4 w-4" />
        </a>
        <button className="text-teal-50 md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="overflow-hidden border-t border-[#163D43] md:hidden" data-testid="nav-mobile-menu">
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map(([id, label]) => (
                <button key={id} onClick={() => go(id)} data-testid={`mobile-link-${id}`} className="font-display py-2 text-left text-2xl text-teal-50">
                  {label}
                </button>
              ))}
              <Link to="/acompanhar" data-testid="mobile-link-track" className="font-display py-2 text-left text-2xl text-[#2DD4BF]">
                Acompanhar pedido
              </Link>
              <a href={waLink(settings?.whatsapp)} target="_blank" rel="noreferrer" className="mt-3 rounded-full bg-[#2DD4BF] px-5 py-3 text-center font-semibold text-[#041214]" data-testid="mobile-whatsapp-cta">
                Fazer pedido no WhatsApp
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
